import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { PayabliConnection } from '@/types/settings';

/**
 * Tenant Payabli connection status (masked paypoint + TEST/LIVE mode).
 * Readable with `company:view`.
 *
 * Read-only by design: a tenant's paypoint is enabled by Notifi support
 * through the provisioner (`PUT /admin/tenants/:id/payabli`), so this app
 * offers no connect or disconnect control. The tenant-facing API routes do
 * still exist under `company:edit`: disconnecting drains before it deletes
 * anything, and `POST …/payabli-connect/cancel-disconnect` undoes it.
 */
export function usePayabliConnection(options: { enabled?: boolean } = {}) {
  return useApiQuery<PayabliConnection>({
    queryKey: settingsKeys.payabliConnection(),
    queryFn: () =>
      apiGet<PayabliConnection>(operationsClient, settingsEndpoints.payabliConnection()),
    enabled: options.enabled ?? true,
    showErrorToast: false,
  });
}
